import { connect } from 'react-redux';
import Diversification, {
  DiversificationProps,
} from '@/components/DeprecatedPortfolio/components/Diversification';
import { portfolioSelector } from '@/components/DeprecatedPortfolio/redux/selectors';
import { get } from 'lodash';

type StateProps = Omit<DiversificationProps, 'sectionNumber'>;
const makeMapStateToProps = () => {
  const mapStateToProps = (state): StateProps => {
    const portfolio = portfolioSelector(state);

    const fundValue = get(portfolio, ['fundValue'], undefined);
    const holdings = get(portfolio, ['holdings'], undefined);
    const isWatchlist = get(portfolio, ['isWatchlist'], false);
    const lastUpdated = get(portfolio, ['lastUpdatedmilliseconds'], 0);
    const portfolioId = get(portfolio, ['id'], '');
    const portfolioName = get(portfolio, ['name'], '');
    const secretCode = get(portfolio, ['secretCode'], undefined);
    const totalValue = get(portfolio, ['totalValue'], null);
    return {
      fundValue,
      holdings,
      isWatchlist,
      lastUpdated,
      portfolioId,
      portfolioName,
      secretCode,
      totalValue,
    };
  };
  return mapStateToProps;
};

type ContainerProps = Pick<DiversificationProps, 'sectionNumber'>;
export default connect<StateProps, unknown, ContainerProps>(
  makeMapStateToProps
)(Diversification);
